import {
  select,
  put,
  call,
  take,
  race,
  cancel,
  takeLatest,
} from 'redux-saga/effects';

import { dashboardFilterActions } from '../filter';
import * as locations from '../requests/locations-req';
import { selectDashboardFilterStatuses } from '../selectors';
import * as appointmentList from '../requests/appointment-list-req';

export function* initFilter() {
  const statusesList = yield select(selectDashboardFilterStatuses);

  const displayableByDefault = statusesList.filter(
    status => status.displayableByDefaultOnDashboard === true,
  );
  const displayableByDefaultIds = displayableByDefault.map(status => status.id);

  yield put(
    dashboardFilterActions.addDisplayableByDefault({
      statuses: [...displayableByDefaultIds],
    }),
  );
}

export function* firstDashboardLoadWorker() {
  yield put(locations.actions.send({ assignedToUser: true }));

  const [error] = yield race([
    take(locations.actions.errorEncountered),
    take(locations.actions.succeed),
  ]);

  if (error) {
    yield cancel();
  }

  yield call(initFilter);
}

export default function* fetchFilteredAppointmentsSaga() {
  yield takeLatest(
    appointmentList.actions.initialLoad,
    firstDashboardLoadWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/dashboard/sagas/fetch-filtered-appointments-saga.js